import * as type from './mutation-type.js'

const mutations = {
    [type.ACTIVE_SAVE](state, active) {
        sessionStorage.active = active;
        state.active = active;
    }
}

export default mutations
